import Button from '../Components/Button';

function E404() {
	return (
		<div className="E404">
			<h1>La page que vous cherchez ne semble pas exister</h1>
			<Button link="/" value="Accueil" />
		</div>
	);
}

export default E404;
